import React from "react";
import { Send } from "lucide-react";

export const TG_SUPPORT_URL = "https://t.me/WS_journal?text=HEY%20I%20HAVE%20ISSUE%20IN%20WS%20JOURNAL";
export const TG_REVIEW_URL = "https://t.me/WS_journal?text=HEY%20HERE%20IS%20MY%20REVIEW%20OF%20WSDT%3A%20";

// Deep-link button that opens a prefilled Telegram message to the WS team.
export const TelegramButton = ({ href = TG_SUPPORT_URL, label = "Message us on Telegram", size = "sm", className = "", testid = "tg-support-btn" }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testid}
     className={`ws-tg-btn ${size === "lg" ? "lg" : ""} ${className}`}>
    <Send className={size === "lg" ? "w-4 h-4" : "w-3.5 h-3.5"} /> {label}
  </a>
);

export default TelegramButton;
